import { combineReducers } from "redux";

import ReactPrettyAlert from "./reactPrettyAlert";

export default combineReducers({ ReactPrettyAlert });
